export default {"src":"/_next/static/media/nora-long.4a88c905.svg","height":784,"width":778,"blurWidth":0,"blurHeight":0};